<template>
	<div>
		<div class="gh-layout">
			<aside class="gh-intro">
				<h2 class="gh-intro__title">Municipalities Filters</h2>
				<p class="gh-intro__desc">Set the default filter UI for the Municipalities page.</p>
			</aside>

			<section class="gh-accounts">
				<div class="ada-card">
					<form @submit.prevent="saveSettings">
						<div class="gh-field">
							<label>Default filter UI</label>
							<select class="form-select" v-model="settings.default">
								<option value="default">Default</option>
								<option value="modern">Modern</option>
							</select>
						</div>
					</form>

					<div v-if="isSrdjan" class="gh-section mt-4">
						<div class="gh-section__title">User overrides</div>
						<div v-if="overrideList.length" class="table-responsive">
							<table class="table table-sm">
								<thead>
									<tr>
										<th>User</th>
										<th>Email</th>
										<th>Mode</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="entry in overrideList" :key="entry.userId">
										<td>{{ entry.name || entry.userId }}</td>
										<td>{{ entry.email || '—' }}</td>
										<td class="text-capitalize">{{ entry.mode }}</td>
									</tr>
								</tbody>
							</table>
						</div>
						<div v-else class="text-muted">No user overrides yet.</div>
					</div>
				</div>
			</section>
		</div>

		<hr class="gh-divider" />

		<div class="gh-save-row">
			<button class="gh-save-btn" type="button" :disabled="saving" @click="saveSettings">
				<i class="fas" :class="saving ? 'fa-spinner fa-spin' : 'fa-save'"></i>
				{{ saving ? 'Saving…' : 'Save changes' }}
			</button>
		</div>

		<hr class="gh-divider" />

		<!-- Municipalities data import lives here — it operates on municipalities. -->
		<ImportExportSettings />
	</div>
</template>

<script>
import { mapState } from 'vuex'
import restApi from '@/api'
import ImportExportSettings from './ImportExportSettings.vue'

export default {
	name: 'MunicipalitiesSettings',
	components: { ImportExportSettings },
	data() {
		return {
			name: 'municipalitiesFiltersUi',
			type: 'settings',
			settings: {
				default: 'default',
				overrides: {},
			},
			saving: false,
		}
	},
	computed: {
		...mapState(['authUser']),
		isSrdjan() {
			return this.authUser?.email?.startsWith('srdjan')
		},
		overrideList() {
			return Object.entries(this.settings.overrides || {}).map(([userId, value]) => {
				if (typeof value === 'string') {
					return { userId, mode: value }
				}
				return {
					userId,
					mode: value?.mode || 'default',
					name: value?.name || '',
					email: value?.email || '',
				}
			})
		},
	},
	created() {
		this.getSettings()
	},
	methods: {
		async getSettings() {
			try {
				const { data } = await restApi.get('/settings', { params: { name: this.name, type: this.type } })
				if (data && data.data) {
					this.settings = JSON.parse(data.data)
					if (!this.settings.default) {
						this.settings.default = 'default'
					}
					if (!this.settings.overrides) {
						this.settings.overrides = {}
					}
				}
			} catch (error) {
				console.error(error)
			}
		},
		async saveSettings() {
			if (this.saving) return
			this.saving = true
			try {
				const payload = {
					default: this.settings.default || 'default',
					overrides: this.settings.overrides || {},
				}
				const { data } = await restApi.post('/settings', {
					name: this.name,
					type: this.type,
					data: JSON.stringify(payload),
				})
				this.settings = JSON.parse(data.data)
			} catch (error) {
				console.error(error)
			} finally {
				this.saving = false
			}
		},
	},
}
</script>
